import { resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { PharmacyInconsistencyFieldType } from './PharmacyInconsistencyFieldType';

export const PharmacyInconsistencyHistory = types.compose(
  'PharmacyInconsistencyHistory',
  BaseEntity,
  types
    .model({
      pharmacyInconsistencyHistoryId: types.identifierNumber,
      pharmacyId: types.maybe(types.number),
      apbNumber: types.number,
      pharmacyInconsistencyFieldTypeId: types.number,
      oldAfmpsValue: types.maybe(types.string),
      oldApbValue: types.maybe(types.string),
      newAfmpsValue: types.maybe(types.string),
      newApbValue: types.maybe(types.string),
      inconsistencyStartDate: types.string,
      inconsistencyEndDate: types.maybe(types.string),
    })
    .views((self) => {
      return {
        get fieldType() {
          return resolveIdentifier(PharmacyInconsistencyFieldType, self, self.pharmacyInconsistencyFieldTypeId);
        },
      };
    }),
);
